module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "message-reply"
  }, [_c('img', {
    attrs: {
      "src": _vm.pictureUrl
    },
    on: {
      "click": _vm.openPersonCard
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "reply-username"
  }, [_c('span', {
    on: {
      "click": _vm.openPersonCard
    }
  }, [_vm._v(_vm._s(_vm.person.firstName) + " " + _vm._s(_vm.person.lastName))])]), _vm._v(" "), _c('p', {
    staticClass: "reply-text"
  }, [_vm._v(_vm._s(_vm.reply.comment))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6290bd0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/question/QuestionReplyBox.vue
// module id = 489
// module chunks = 0